import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import aboutImg from '../assets/about_us_clean.png'
import { useTranslation } from 'react-i18next';

const AboutUs = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-3" style={{ backgroundColor: 'var(--color-surface)' }}>
      <Container className="py-5">
        <Row className="align-items-center mb-5">
          <Col lg={6} className="mb-4 mb-lg-0 pe-lg-5" data-aos="fade-right">
            <h6 className="text-uppercase mb-3" style={{ color: 'var(--color-accent)', letterSpacing: '2px', fontWeight: 'bold' }}>
              {t('aboutUs.subtitle')}
            </h6>
            <h2 className="display-5 fw-bold text-black mb-4" style={{ fontFamily: 'var(--font-serif)' }}>
              {t('aboutUs.title')}
            </h2>
            <div style={{ width: '60px', height: '3px', backgroundColor: 'var(--color-accent)' }} className="mb-4"></div>
            <p className="lead text-dark mb-4">
              {t('aboutUs.lead')}
            </p>
            <p className="text-dark opacity-50 mb-4" style={{ lineHeight: '1.8' }}>
              {t('aboutUs.p1')}
            </p>
            <p className="text-dark opacity-50 mb-0 fw-bold" style={{ fontStyle: 'italic' }}>
              {t('aboutUs.p2')}
            </p>
          </Col>
          <Col lg={6} className="text-center" data-aos="fade-left" data-aos-delay="200">
            <div className="position-relative">
              <img 
                src={aboutImg} 
                alt="JD GEMS Exquisite Diamond" 
                className="img-fluid"
                style={{ 
                  maxHeight: '450px', 
                  filter: 'drop-shadow(0 20px 30px rgba(0,0,0,0.1))',
                  mixBlendMode: 'multiply' 
                }}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutUs;
